module.exports = __webpack_public_path__ + "img/pytrace-graph-view.9b88071a.png";